export default "__VITE_ASSET__5c2c4c08__"